/**
 * Make an animation fade out/in between two html element in js
 * @param {HTMLElement} outElement Html element to disappear
 * @param {HTMLElement} inElement  Html element to appear
 * @param {Array} durations array of OutDuration and InDuration
 */
export const FadeOutIn = (outElement, inElement, [durationOut, durationIn] = [300, 500]) => {

    // apply animation Out
    outElement.style.transition = `opacity ${durationOut}ms ease`;
    outElement.style.opacity    = "0";

    // wait duration of out animation
    setTimeout(() => {
        // disappear out element
        outElement.style.visibility = "hidden";
        outElement.style.display = "none";

        // appear element in
        inElement.style.visibility = "visible";
        inElement.style.display    = "block";

        // wait for good animation
        setTimeout(() => {
            // apply animation In
            inElement.style.transition = `opacity ${durationIn}ms ease`;
            inElement.style.opacity    = "1";
        }, 10);

    }, durationOut);
}